import config from '../../config.json';

function createDefault() {
    return {
        rk: null,
        name: '',
        service: 'Jerny.UmlWorkspace',
        format: 'class-diagram',
        remarks: '',
        shapes: [],
        connectors: [],
    };
}

function fromNote(note) {
    const body = JSON.parse(note.body);

    const r = {
        rk: note.rk,
        name: note.title ?? '',
        service: note.service ?? 'Jerny.UmlWorkspace',
        format: note.format ?? 'class-diagram',
        remarks: note.remarks ?? '',
        shapes: body.shapes ?? [],
        connectors: body.connectors ?? [],
        viewConfig: body.viewConfig ?? {},
        viewport: body.viewport ?? {},
    };

    return r;
}

// function toEnvelope(form) {
//     return {
//         rk: form.rk,
//         app: config.appName,
//         type: 'UmlSchema',
//         ver: '1.0',
//         data: JSON.stringify({
//             name: form.name,
//             service: form.service,
//             format: form.format,
//             remarks: form.remarks,
//             shapes: form.shapes,
//             connectors: form.connectors,
//         }),
//     };
// }

const umlSchemaFormData = { createDefault, fromNote };
export default umlSchemaFormData;
